/**
 *
 * Audiences
 *
 */

import React, { useState, useEffect, useCallback } from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";

// styles
import "./style.scss";

// antd component
import { Dropdown } from "antd";

// assets
import { DownOutlined } from "@ant-design/icons";
// import CustomIcons from 'components/CustomIcons';

// utils
import { parseQuery } from "utils/history";
import _local from "utils/localStorageUtils";

// context
import { withUser } from "engine/Contexts/User.context";

function SchoolDropdown({
  // main
  // context
  user,
  //default
  className,
}) {
  const childClassNames = classNames("school-dropdown-wrapper", className);
  const { t, i18n } = useTranslation();
  const language = localStorage.getItem('i18nextLng') || process.env.DEFAULT_LANGUAGE || "fr";

  const localUser = _local.getLocalUser();

  const [open, setOpen] = useState(false);
  const [schools, setSchools] = useState(false);
  const [schoolsList, setSchoolsList] = useState(false);
  const [activeSchool, setActiveSchool] = useState(false);

  // INFO: disable ability to change language based on school language, latest changes from client on 02.2024
  /* const chageLanguage = useCallback(lang => { 
    if (lang != i18n.language) { 
      i18n.changeLanguage(!!lang && lang || language); 
    }
  }, [i18n.language, language]); */
  
  const changeActiveSchool = useCallback((school) => { 
    if (!!school && school?.key != activeSchool?.key) { 
      setActiveSchool(school);
      // INFO: disable ability to change language based on school language, latest changes from client on 02.2024
      //chageLanguage(school?.language);
      _local.setLocalSchool(school);
    }
  }, [i18n.language, language, activeSchool]);

  useEffect(() => {
    // root list
    const schools =
      user?.schools?.length > 0 ? user?.schools : localUser?.schools || [];
    setSchools(schools);
    // active item
    const localActiveSchool = _local.getLocalSchool();
    const school = (!!localActiveSchool && localActiveSchool) || schools?.[0];
    changeActiveSchool(school);
    // list
    const list = schools?.map(sch => ({
      label: sch?.name || sch?.key,
      key: sch?.key, // ! main param
      _id: sch?._id,
    }));
    setSchoolsList(list);
  }, []);

  useEffect(() => {
    // root list
    const schools =
      user?.schools?.length > 0 ? user?.schools : localUser?.schools || [];
    setSchools(schools);

    // active item
    if (!!!activeSchool) {
      const localActiveSchool = _local.getLocalSchool();
      const school =
        (!!localActiveSchool && localActiveSchool) || schools?.[0];
      changeActiveSchool(school);
    }
    // list
    const list = schools?.map(sch => ({
      label: sch?.name || sch?.key,
      key: sch?.key, // ! main param
      _id: sch?._id,
    }));
    setSchoolsList(list);
  }, [user?.schools]);

  const handleOpenChange = flag => {
    setOpen(flag);
  };

  const handleMenuClick = useCallback(({ item, key, keyPath, domEvent }) => {
    const currentSchool = schools?.find(sch => sch?.key == key);
    if (!!currentSchool?.key && currentSchool?.key != activeSchool?.key) {
      changeActiveSchool(currentSchool);
      window.location.reload();
    }
    setOpen(false);
  }, [schools, activeSchool]);

  // render function
  return (
    <div className={childClassNames}>
      {schoolsList?.length > 0 ? (
        <Dropdown
          menu={{
            items: schoolsList,
            onClick: handleMenuClick,
          }}
          trigger={["click"]}
          onOpenChange={handleOpenChange}
          open={open}
          overlayClassName="school-dropdown-list"
          getPopupContainer={trigger => trigger.parentElement}
        >
          <a className="default" onClick={e => e.preventDefault()}>
            {activeSchool?.name || activeSchool?.key}
            <DownOutlined />
          </a>
        </Dropdown>
      ) : (
        activeSchool?.name || activeSchool?.key
      )}
    </div>
  );
}

export default withUser(SchoolDropdown);
